var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnlinePayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "img"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    cx: 20,
    cy: 20,
    r: 20,
    fill: props.color
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trailing-icon",
    clipPath: "url(#onlinePayment)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.2 13H12.8C11.801 13 11.009 13.7788 11.009 14.75L11 25.25C11 26.2212 11.801 27 12.8 27H27.2C28.199 27 29 26.2212 29 25.25V14.75C29 13.7788 28.199 13 27.2 13ZM26.3 25.25H13.7C13.205 25.25 12.8 24.8562 12.8 24.375V20H27.2V24.375C27.2 24.8562 26.795 25.25 26.3 25.25ZM27.2 16.5H12.8V14.75H27.2V16.5Z",
    fill: "#82858B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "onlinePayment"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlinePayment);
export default __webpack_public_path__ + "static/media/onlinePayment.85ec85a57de9149ca98c2228ad1e7358.svg";
export { ForwardRef as ReactComponent };